import { Injectable } from "@angular/core";
import { firstValueFrom, Observable, Subject, Subscription } from "rxjs";
import { LocationRelatedAPIService } from "../../shared/services/API/LocationRelatedAPI.service";
import { LocationRelatedDTO } from "../models/LocationRelatedDTO";
import { EstatusJSON } from "../../shared/models/EstatusJSON";
import { LocationsService } from "./Locations.service";
import { MatDialog } from "@angular/material/dialog";
import { GeneralLocationsDetailsPopUpComponent } from "../components/panel-detail-locations/location-popup-details/general-location-detail-popup/general-location-details-popup.component";
import { LocationDTO } from "../models/LocationDTO";
import { DataNamesDTO } from "../models/DataNamesDTO";
import { IGeoPosDataLocation } from "../../routeMap/models/IDataLocation";
import { CitronellaActionsService } from "../../shared/services/ServiceCatalogEncapsulators/CitronellaActions.service";
import { LocationRelatedTicketPopupComponent } from "../components/panel-detail-locations/location-related/location-related-ticket-popup/location-related-ticket-popup.component";
import { SwalNotificationService } from "../../shared/services/SwalNotification.service";
import { RouteSheetLocationDTO } from "../models/RouteSheetLocationDTO";
import { EnumLocationCategories } from "../../shared/helpers/enums/EnumLocationCategories";
import { ServiceLocationDetailPopupComponent } from "../components/panel-detail-locations/location-popup-details/service-location-detail-popup/service-location-detail-popup.component";
import { LocationsLocationDetailPopupComponent } from "../components/panel-detail-locations/location-popup-details/locations-location-detail-popup/locations-location-detail-popup.component";


@Injectable({
  providedIn: "root",
})
export class RouteSheetService{

  public isLoadingList: boolean = false;

  //para panel related details como popup
  public dialogDetailsRef: any = null;
  locationDTO: LocationDTO;
  keys: string[] = [];
  values: string[] = [];
  keyNames: DataNamesDTO[] = [];
  arrayMaster: any[] = [];
  images: string[] = [];

  isForceReload: boolean = false;

  location_details_subscription: Subscription;
  location_route_subscription: Subscription;

  constructor(
    private locationService: LocationsService, 
    private dialog: MatDialog,
    private citronellaActionsService: CitronellaActionsService,
    private notifyService: SwalNotificationService) {
  }

  openRouteSheetDetailsPopup( routeSheetLocation: RouteSheetLocationDTO, parentCoordX: string, parentCoordY: string) {
      if (this.dialogDetailsRef) {
        this.dialogDetailsRef.close();
        this.dialogDetailsRef = null;
      }
      var popupData = {
            identifierParent : routeSheetLocation.identifierParent,
            identifier: routeSheetLocation.identifierChild,
            parentCoordX: parentCoordX,
            parentCoordY: parentCoordY,
            FlyToOnOpen: true,
            FlyToParentOnClose: false
          };
      var categoryName = JSON.parse( localStorage.getItem("listaCategorias")).find((category: any) => category.id === routeSheetLocation.idLocationCategory)?.name;
      console.log("categoryName", categoryName, routeSheetLocation);
      
      if (categoryName?.includes(EnumLocationCategories.Service)) {
        this.dialogDetailsRef = this.dialog.open( ServiceLocationDetailPopupComponent,
          {
            maxWidth: "98vw",
            maxHeight: "92vh",
            autoFocus: false,
            restoreFocus: false,
            hasBackdrop: false,
            disableClose: true,
            data: popupData,
          }
        );
      } else if(categoryName?.includes(EnumLocationCategories.Location)) {
        this.dialogDetailsRef = this.dialog.open( LocationsLocationDetailPopupComponent,
          {
            maxWidth: "98vw",
            maxHeight: "92vh",
            autoFocus: false,
            restoreFocus: false,
            hasBackdrop: false,
            disableClose: true,
            data: popupData,
          }
        );
      }else{
        this.dialogDetailsRef = this.dialog.open( GeneralLocationsDetailsPopUpComponent,
          {
            maxWidth: "98vw",
            maxHeight: "92vh",
            autoFocus: false,
            restoreFocus: false,
            hasBackdrop: false,
            disableClose: true,
            data: popupData,
          }
        );
      }

      //añade el z-index al contenedor del overlay para que esté debajo del nav
      const overlayContainer = document.querySelector(".cdk-overlay-container") as HTMLElement;
      if (overlayContainer) {
        overlayContainer.style.zIndex = "4";
      }

      this.dialogDetailsRef.afterClosed().subscribe((result) => {
        console.log("cerrado");
        this.dialogDetailsRef = null;
        if(this.location_details_subscription)
          this.location_details_subscription.unsubscribe();
        //quita el z-index del contenedor del overlay
        const overlayContainer = document.querySelector(".cdk-overlay-container") as HTMLElement;
        if (overlayContainer) {
          overlayContainer.style.removeProperty("z-index");
        }
      });
      
    }

  }
